import { cn } from '@/utils/cn';

const Tag = ({
  text,
  type,
  isSure,
}: {
  type: 'solid' | 'outline';
  text: string;
  isSure?: boolean;
}) => {
  return (
    <div
      className={cn('rounded-full border px-2 text-sub5 tracking-l', {
        'bg-primary-060 text-grey-000 border-primary-060': type === 'solid',
        'text-grey-060 border-grey-060 bg-grey-000': type === 'outline',
        'bg-sure-060 text-grey-000 border-sure-060': isSure,
      })}
    >
      {text}
    </div>
  );
};

const VehicleCard = ({
  tag,
  title,
  imgUrl,
  price,
  isSure,
  onClick,
  isDisabled,
}: {
  tag: {
    text: string;
    type: 'solid' | 'outline';
  }[];
  imgUrl: string;
  title: string;
  price: string;
  onClick: () => void;
  isSure?: boolean;
  isDisabled?: boolean;
}) => {
  return (
    <div
      className={cn(
        'flex h-[270px] w-full cursor-pointer flex-col gap-2 rounded-m border border-grey-010 bg-grey-000 p-5 hover:bg-grey-010',
        isDisabled && 'cursor-not-allowed bg-grey-005 hover:bg-grey-005',
        isSure && 'border-sure-010 p-5',
      )}
      onClick={() => {
        if (isDisabled) return;
        onClick();
      }}
    >
      {/* 태그 */}
      <div className='flex gap-1'>
        {tag.map((t) => (
          <Tag key={t.text} text={t.text} type={t.type} isSure={isSure} />
        ))}
      </div>

      {/* 이미지 */}
      <img
        src={imgUrl}
        width={224}
        height={123}
        alt={title}
        className='flex-1 select-none'
        style={{ objectFit: 'cover' }}
      />

      {/* 세부정보 */}
      <div className='flex select-none flex-col gap-1'>
        <p className='text-sub3 tracking-m text-grey-050'>{title}</p>
        <p className='text-sub2 tracking-s text-grey-080'>{price}</p>
      </div>
    </div>
  );
};

export default VehicleCard;
